import { useState } from "react";
import { Lock, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

export default function PinLock() {
  const { user, unlock, logout } = useAuth();
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await unlock(pin);
      toast.success("PIN benar. Selamat bekerja!");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050914] flex items-center justify-center p-6 relative overflow-hidden" data-testid="pin-lock-screen">
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_50%_20%,rgba(240,78,35,0.12),transparent_60%)]" aria-hidden="true" />
      <div className="w-full max-w-xs text-center relative z-10">
        <div className="w-16 h-16 rounded-3xl bg-[#F04E23]/10 border border-[#F04E23]/25 flex items-center justify-center mx-auto mb-5">
          <Lock className="w-7 h-7 text-[#F04E23]" />
        </div>
        <h1 className="font-heading text-xl font-bold tracking-tight text-white">Akses Terkunci</h1>
        <p className="text-sm text-slate-400 mt-1 mb-6">
          Halo, <span className="font-medium text-slate-200">{user?.name}</span>.<br />
          Masukkan PIN Anda untuk mulai mengakses & bertransaksi.
        </p>
        <form onSubmit={submit} className="space-y-3">
          <Input
            type="password" inputMode="numeric" autoFocus maxLength={8}
            value={pin} onChange={(e) => setPin(e.target.value)}
            placeholder="••••••"
            className="text-center text-2xl tracking-[0.5em] h-14 font-mono bg-[#0A1020] border-[#1A2644] text-white placeholder:text-slate-600"
            data-testid="input-unlock-pin"
          />
          {error && <div className="text-sm text-rose-400" data-testid="pin-lock-error">{error}</div>}
          <Button type="submit" className="w-full bg-[#F04E23] hover:bg-[#D83E15] text-white shadow-lg shadow-[#F04E23]/25 active:scale-[0.98] transition-all" disabled={busy || pin.length < 4} data-testid="btn-unlock">
            {busy ? "Memeriksa..." : "Buka Akses"}
          </Button>
        </form>
        <button onClick={logout} className="mt-6 text-xs text-slate-500 hover:text-slate-300 inline-flex items-center gap-1 transition-colors" data-testid="btn-pin-lock-logout">
          <LogOut className="w-3.5 h-3.5" /> Keluar / ganti akun
        </button>
      </div>
    </div>
  );
}
